import { useContext } from 'react'

import { ConfigCompradorContext } from '@provider/FollowUpFornecedor/ConfigCompradorProvider'

import { IConfigCompradorContext } from '@base/@types/providers/FollowUpFornecedor/ConfigCompradorProvider'

export default function useFollowUpConfigComprador(): IConfigCompradorContext {
  return useContext(ConfigCompradorContext)
}
